/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { addCorrectionNote, editCorrectionNote, getCorrectionNote, showDocument } from "@/requests/document";
import { CorrectionNote } from "@/models/api/documents/CorrectionNote";
import { DocumentsListItem } from "@/models/api/documents/DocumentsList";
import { getLocalContractor } from "@/requests/contractors";

export interface DocumentsCorrectionNoteStateInterface {
  isDialog: boolean;
  correctionNoteRequest: CorrectionNote;
  documentId: null | string;
}

export const DocumentsCorrectionNoteState: DocumentsCorrectionNoteStateInterface = {
  isDialog: false,
  correctionNoteRequest: new CorrectionNote(),
  documentId: null,
};

const DocumentsCorrectionNoteModule = defineModule({
  state: DocumentsCorrectionNoteState as DocumentsCorrectionNoteStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setIsDialog(state, param: boolean) {
      state.isDialog = param;
    },
    setCorrectionNote(state, param: CorrectionNote) {
      state.correctionNoteRequest = param;
    },
    setDocumentId(state, param: null | string) {
      state.documentId = param;
    },
  },
  actions: {
    async openCorrectionNoteDialog(context) {
      const { commit, rootDispatch } = _moduleActionContext(context);
      commit.setDocumentId(null);
      const correctionNote = new CorrectionNote();
      const officeContractor = await rootDispatch.contractors.getOfficeContractor();
      correctionNote.buyer = CorrectionNote.getContractorString(officeContractor);
      correctionNote.contractor = CorrectionNote.getContractorString(officeContractor);
      commit.setCorrectionNote(correctionNote);
      commit.setIsDialog(true);
    },
    async openCorrectionNoteDialogFromDocument(context, document: DocumentsListItem) {
      const { commit, rootDispatch } = _moduleActionContext(context);
      const correctionNote = new CorrectionNote();
      commit.setDocumentId(null);
      const officeContractor = await rootDispatch.contractors.getOfficeContractor();
      correctionNote.addressee = CorrectionNote.getContractorString(officeContractor);
      correctionNote.seller = CorrectionNote.getContractorString(officeContractor);
      correctionNote.issueDate = document.issueDate;
      correctionNote.saleDate = document.saleDate;
      const documentLocalContractor = await getLocalContractor(document.contractorId);
      correctionNote.contractor = CorrectionNote.getContractorString(documentLocalContractor);
      correctionNote.buyer = CorrectionNote.getContractorString(documentLocalContractor);
      correctionNote.documentId = document.id;
      correctionNote.invoiceNumber = document.documentNumber;
      commit.setCorrectionNote(correctionNote);
      commit.setIsDialog(true);
    },
    async openEditCorrectionNoteDialog(context, documentId: string) {
      const { commit } = _moduleActionContext(context);
      commit.setDocumentId(documentId);
      commit.setCorrectionNote(await getCorrectionNote(documentId));
      commit.setIsDialog(true);
    },
    async saveCorrectionNote(context): Promise<void> {
      const { commit, state, rootDispatch } = _moduleActionContext(context);
      let correctionNoteResponse;
      let documentIdToShow = "";
      if (state.documentId === null) {
        correctionNoteResponse = await addCorrectionNote(state.correctionNoteRequest);
        documentIdToShow = correctionNoteResponse.documentId;
      } else {
        correctionNoteResponse = await editCorrectionNote(state.correctionNoteRequest, state.documentId);
        documentIdToShow = state.documentId;
      }
      await showDocument(documentIdToShow);
      commit.setIsDialog(false);
      rootDispatch.popup.addOperationSuccessfulSnackbar();
      await rootDispatch.documents.getDocumentsTable();
    },
  },
});

export default DocumentsCorrectionNoteModule;

/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, DocumentsCorrectionNoteModule);
const _moduleActionContext = (context: any) => moduleActionContext(context, DocumentsCorrectionNoteModule);
